/**
 * Shared visual constants for the tours calendar, mirroring the approved
 * design so the toolbar, day headers, and grid stay in sync.
 */
export const CALENDAR_ACCENT = '#15a05f';
export const CALENDAR_NOW_INDICATOR = '#ea4335';
export const CALENDAR_TEXT = '#3c4043';
export const CALENDAR_TEXT_MUTED = '#70757a';
